import React from 'react';
import { StyleSheet, TouchableOpacity } from 'react-native';

import ChevronRight from '@/assets/icons/chevronRight';
import { ds } from '@/components/lib/design.system';

export type ArrowButtonProps = { direction: 'right' | 'left'; onPress: () => void };

export const ArrowButton = ({ direction, onPress }: ArrowButtonProps) => (
    <TouchableOpacity
        onPress={onPress}
        style={[styles.arrowButton, direction === 'left' ? styles.leftArrow : styles.rightArrow]}
    >
        <ChevronRight color={ds.colorValue.icon.primary} style={direction === 'left' ? styles.transformLeft : null} />
    </TouchableOpacity>
);

const styles = StyleSheet.create({
    transformLeft: {
        transform: [{ rotate: '-180deg' }],
    },
    arrowButton: {
        backgroundColor: ds.colorValue.background.neutral.base,
        padding: 8,
        borderRadius: 20,
        borderCurve: 'continuous',
    },
    leftArrow: {
        position: 'absolute',
        left: 10,
        zIndex: 1,
    },
    rightArrow: {
        position: 'absolute',
        right: 10,
        zIndex: 1,
    },
});
